import { ApplicationStage } from '@internal/types/profile';

export const PHASE_1_STAGES: ReadonlySet<ApplicationStage> = new Set([
  ApplicationStage.QualificationStarted,
  ApplicationStage.ResumeConfirmed,
  ApplicationStage.RoleConfirmed,
  ApplicationStage.AiCallStarted,
  ApplicationStage.AiCallCompleted,
  ApplicationStage.ManualFormStarted,
  ApplicationStage.ManualFormCompleted,
  ApplicationStage.TechPreScreeningStarted,
  ApplicationStage.TechPreScreeningCompleted,
]);

export const isPhase1Stage = (
  stage: ApplicationStage | null | undefined
): boolean =>
  stage !== null && stage !== undefined && PHASE_1_STAGES.has(stage);

const POST_PROFILE_SUBMISSION_STAGES: ReadonlySet<ApplicationStage> = new Set([
  ApplicationStage.ProfileSubmittedForReview,
  ApplicationStage.ScreeningCallInvitationSent,
  ApplicationStage.ScreeningCallBooked,
  ApplicationStage.ScreeningCallMade,
  ApplicationStage.HardSkillsInvitationSent,
  ApplicationStage.HardSkillsInterviewBooked,
  ApplicationStage.HardSkillsInterviewMade,
  ApplicationStage.FinalBriefingStarted,
  ApplicationStage.OnboardedToCommunity,
]);

export const isProfileSubmittedForReview = (
  stage: ApplicationStage | null | undefined
): boolean =>
  stage !== null &&
  stage !== undefined &&
  POST_PROFILE_SUBMISSION_STAGES.has(stage);
